module.exports = __webpack_public_path__ + "static/media/thubnail.e7c4c9bd.png";